import request from '@/utils/httpRequest'

export default class MarketService {
    queryById(id){
        return request({
            url:'/shye/base/marketResearch/queryById',
            method:'get',
            params:{id:id}
        })
    }

    startFlow (params) {
        return request({
            url: '/shye/base/marketResearch/startFlow',
            method: 'post',
            data: params
        })
    }

}
